//
// True when a request path carries a value that never got filled in, such as
// "/logos/undefined/aBcD". The server refuses those as malformed identifiers,
// which counts towards a ban of the address, so the client must not send them.
//
const missingValues = ['undefined', 'null', 'NaN'];

const urlPathHasMissingValue = (urlPath) => {
  if (!urlPath) return false;

  const [path, query] = String(urlPath).split('?');

  if (path.split('/').some((segment) => missingValues.includes(segment))) return true;

  if (!query) return false;

  return query
    .split('&')
    .some((pair) => missingValues.includes(decodeURIComponent(pair.split('=')[1] ?? '')));
};

export default urlPathHasMissingValue;
